import { GetServerSideProps, NextPage } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
// Features
import PageBanner from '@utmb/features/page-banner/PageBanner';
import { SlicesHandler } from '@utmb/features/slices-handler/SlicesHandler';
// Design system
import { Layout } from '@utmb/layouts/layout-base';
// Interfaces
import { LangEnum, PageDefaultProps, PageView } from '@utmb/types/index';
// Context, utils
import { i18n } from 'next-i18next.config';
import { PageProviders } from '@utmb/contexts/index';
import isMobile from '@utmb/utils/is-mobile';
import { fetchAPI } from '@utmb/utils/utmb';

interface PageProps extends PageDefaultProps, PageView {}

const IndexPage: NextPage<PageProps> = ({
    banner,
    breadcrumbs,
    contentLocale,
    event,
    eventsTopBar,
    footer,
    host,
    isMobile,
    mobileBottomBar,
    navigation,
    simpleMenu,
    seo,
    slices,
    partners,
    languages,
}) => {
    return (
        <PageProviders>
            <Layout
                {...seo}
                contentLocale={contentLocale}
                host={host}
                isMobile={isMobile}
                eventsTopBar={eventsTopBar}
                mobileBottomBar={mobileBottomBar}
                navigation={navigation}
                simpleMenu={simpleMenu}
                footer={footer}
                event={event}
                partners={partners}
                languages={languages}
                breadcrumbs={breadcrumbs}
            >
                {banner && <PageBanner {...banner} />}
                <SlicesHandler slices={slices} />
            </Layout>
        </PageProviders>
    );
};

export default IndexPage;

export const getServerSideProps: GetServerSideProps<PageView> = async ({ locale, defaultLocale, req }) => {
    try {
        // Translate
        const lang: LangEnum = (locale || defaultLocale || i18n.defaultLocale) as LangEnum;
        const translations = await serverSideTranslations(lang, ['common']);

        const host = req.headers.host;

        // Page Content
        const page = await fetchAPI(req, '/content/pages', '/races-runners/runners', { lang });
        // if error
        if (!page) return { notFound: true };
        const { banner, noIndex, seo, slices, slug, breadcrumbs, locale: contentLocale } = page;

        return {
            props: {
                banner,
                breadcrumbs,
                contentLocale,
                host,
                isMobile: isMobile(req),
                locale: lang,
                noIndex,
                seo,
                slices,
                slug,
                ...translations,
            },
        };
    } catch (error) {
        return {
            notFound: true,
        };
    }
};
